import moment from 'moment';

export default class AccountSnapshotFormValidator {
  startDate: moment.Moment;

  endDate: moment.Moment;

  constructor(startDate: string, endDate: string) {
    this.startDate = moment(startDate, 'YYYY-MM-DD', true);
    this.endDate = moment(endDate, 'YYYY-MM-DD', true);
  }

  validate() {
    if (!this.startDate.isValid() || !this.endDate.isValid()) {
      return false;
    }
    if (this.endDate > moment()) {
      return false;
    }
    if (this.startDate > this.endDate) {
      return false;
    }
    if (this.endDate.diff(this.startDate, 'days') > 365) {
      return false;
    }
    return true;
  }
}
